import Logo from "../assets/img/logo/HD_wit_transparant_no_text_icon.png";
import { useState } from "react";
import { Transition } from "react-transition-group";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { HashLink } from "react-router-hash-link";

export default function Navbar() {
  /* State for transitioning between hidden/visible mobile dropdown */
  const [dropdownMobile, setDropdownMobile] = useState(false);
  const handleClick = () => {
    setDropdownMobile(!dropdownMobile);
  };

  /* Styling objects for react-transition library for smooth transition between states */
  const defaultStyles = {
    visibility: "hidden",
    transition: `all 0.3s ease`,
    opacity: 0,
  };
  const transitionStyles = {
    entering: { opacity: 1, visibility: "visible" },
    entered: { opacity: 1, visibility: "visible" },
    exiting: { opacity: 0 },
    exited: { opacity: 0 },
  };

  return (
    <div id="navbar">
      <div className="navbar__container flex">
        <HashLink smooth to="/">
          <div
            className="navbar__logo"
            style={{ backgroundImage: `url(${Logo})` }}
          ></div>
        </HashLink>

        {/* MOBILE NAVIGATION */}
        <div className="navbar__hamburger flex" onClick={handleClick}>
          {dropdownMobile ? <AiOutlineClose /> : <AiOutlineMenu />}
        </div>

        <Transition in={dropdownMobile} timeout={300}>
          {(state) => (
            <div
              className="navbar__dropdown_mobile"
              style={{
                ...defaultStyles,
                ...transitionStyles[state],
              }}
            >
              <div className="navbar__internal_links flex">
                <HashLink smooth to="/#info">
                  Info
                </HashLink>
                <HashLink smooth to="/#agenda">
                  Agenda
                </HashLink>
                <HashLink smooth to="/#doneren">
                  Doneren
                </HashLink>
                <HashLink
                  smooth
                  to="mailto:secretariaat@harpedavidsbrunssum.net?subject=Lidmaatschap&body=Hallo%2C%0A%0AIk%20zou%20graag%20lid%20willen%20worden.%0A%0A%3Cvul%20hier%20je%20contact%20informatie%20in%3E"
                >
                  Lid worden
                </HashLink>
              </div>
            </div>
          )}
        </Transition>

        {/* DESKTOP NAVIGATION  */}

        <div className="navbar__desktop">
          <div className="navbar__internal_links">
            <HashLink smooth to="/#info">
              Info
            </HashLink>
            <HashLink smooth to="/#agenda">
              Agenda
            </HashLink>
            <HashLink smooth to="/#doneren">
              Doneren
            </HashLink>
            <HashLink
              smooth
              to="mailto:secretariaat@harpedavidsbrunssum.net?subject=Lidmaatschap&body=Hallo%2C%0A%0AIk%20zou%20graag%20lid%20willen%20worden.%0A%0A%3Cvul%20hier%20je%20contact%20informatie%20in%3E"
            >
              Lid worden
            </HashLink>
          </div>
        </div>
      </div>
    </div>
  );
}
